import { externalEvents } from "@closerplatform/closer-sdk";
import { AppPresence } from "@closerplatform/spinner-openapi";

import { WsEventListener } from "@fidget/common/services/eventsListener";
import { IAgentStore } from "./AgentStore";

export class AgentEventListener implements WsEventListener {
  constructor(private _agentStoreFinder: () => IAgentStore, public name: string) {}

  get agentStore(): IAgentStore {
    return this._agentStoreFinder();
  }

  presenceUpdated(event: externalEvents.PresenceUpdated) {
    const agent = this.agentStore.agents.get(event.userId);
    if (agent) {
      agent.setPresence(event.presence as unknown as AppPresence, event.reason);
    }
  }

  connected() {
    // FIXME: switch off till AgentPresenter/UserService refactoring is done.
    // this.agentStore.clear();
  }
}
